"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirPlay = exports.AirPlayEvent = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
exports.AirPlayEvent = {
    AVAILABILITY_CHANGED: "airplay:availability_changed",
    CONNECTED: "airplay:connected",
    DISCONNETED: "airplay:disconnected",
};
class AirPlay extends js_player_shared_1.EmitterBaseClass {
    constructor(video) {
        super();
        this.isEnabled = true;
        this.isAvailable = false;
        this.isBrowserSupported = false;
        this.video = video;
        if (!window.WebKitPlaybackTargetAvailabilityEvent) {
            this.isBrowserSupported = false;
            this.emit(exports.AirPlayEvent.AVAILABILITY_CHANGED, { available: false });
        }
        else {
            this.isBrowserSupported = true;
            video.addEventListener("webkitplaybacktargetavailabilitychanged", (this.onAvailabilityChanged = this.onAvailabilityChanged.bind(this)));
            video.addEventListener("webkitcurrentplaybacktargetiswirelesschanged", (this.onTargetChanged = this.onTargetChanged.bind(this)));
        }
    }
    onAvailabilityChanged({ availability }) {
        if (!this.isEnabled) {
            // Safari considers airplay available even if we've disabled it
            // however _only_ airplaying the audio is supported, since that is confusing
            // for users we disable it internally as well.
            return;
        }
        this.isAvailable = availability === "available";
        this.emit(exports.AirPlayEvent.AVAILABILITY_CHANGED, {
            available: this.isAvailable,
        });
    }
    onTargetChanged() {
        if (this.video.webkitCurrentPlaybackTargetIsWireless) {
            this.emit(exports.AirPlayEvent.CONNECTED, undefined);
            // workaround safari bug causing the video element to not receive some events
            // wait one tick and then play to trigger the video element to get events again
            setTimeout(() => {
                this.video.play();
            }, 0);
        }
        else {
            this.emit(exports.AirPlayEvent.DISCONNETED, undefined);
        }
    }
    isSupported() {
        return this.isBrowserSupported;
    }
    enable() {
        this.isEnabled = true;
        this.video.removeAttribute("x-webkit-airplay");
        this.video.removeAttribute("x-webkit-wirelessvideoplaybackdisabled");
        this.emit(exports.AirPlayEvent.AVAILABILITY_CHANGED, {
            available: this.isAvailable,
        });
    }
    disable() {
        this.isEnabled = false;
        this.video.setAttribute("x-webkit-airplay", "deny");
        this.video.setAttribute("x-webkit-wirelessvideoplaybackdisabled", "");
        this.emit(exports.AirPlayEvent.AVAILABILITY_CHANGED, {
            available: false,
        });
    }
    toggleAirPlay() {
        this.video.webkitShowPlaybackTargetPicker();
    }
    destroy() {
        this.video.removeEventListener("webkitplaybacktargetavailabilitychanged", this.onAvailabilityChanged);
        this.video.removeEventListener("webkitcurrentplaybacktargetiswirelesschanged", this.onTargetChanged);
    }
}
exports.AirPlay = AirPlay;
//# sourceMappingURL=AirPlay.js.map